import { legacyLogin } from "../../services/restAPI/endpoints/LegacyLogin";
import { userHeadlessSignIn } from "../../appRedux/actions/Auth";
import { store } from "../../appRedux/store/Store";

export async function login(userKey) {
   return legacyLogin(userKey).then((response) => {
      localStorage.removeItem("publicID");
      localStorage.removeItem("isPublicUserLogged");
      localStorage.setItem("token", response.data[0].cloudToken);

      return new Promise((resolve) => {
         const unsubscribe = store.subscribe(() => {
            const state = store.getState();
            if (state.auth?.authUser?.id) {
               unsubscribe();
               resolve();
            }
         });

         store.dispatch(userHeadlessSignIn());
      });
   });
}
